var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverPointSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 30v2H6v-2h20Zm4-4V6a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4v2l-.309-.008A6 6 0 0 1 0 26V6a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6v-2a4 4 0 0 0 4-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverPointSquare);
export default __webpack_public_path__ + "static/media/hover_point_square.291c0334f7971b3285568036d9ae1f89.svg";
export { ForwardRef as ReactComponent };